import { useCallback } from 'react'
import { useBulkApproveTimeEntries } from '@/hooks/useBulkApproveTimeEntries'

export function useDailyActivityCard(entryIds: string[], orgId: string) {
    const bulkApprove = useBulkApproveTimeEntries()

    const approveDay = () => {
        bulkApprove.mutate({ entryIds, orgId })
    }

    const approveEntry = useCallback(
        (entryId: string) => {
            bulkApprove.mutate({ entryIds: [entryId], orgId })
        },
        [bulkApprove, orgId]
    )

    return { approveDay, approveEntry, isApproving: bulkApprove.isPending }
}
